import { render } from "./NavbarVue.vue?vue&type=template&id=2a766b28"
import script from "./NavbarVue.vue?vue&type=script&lang=js"
export * from "./NavbarVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__